export default "__VITE_ASSET__4cHdNfJ4__"